/* SG product page UI (sections/sg-product.liquid). No dependencies.
   The variant / add-to-cart flow stays legacy (Shopify.OptionSelectors +
   selectCallback + timber.productPage + product-cart-action). This adds:
   - gallery: swipe/scroll-snap slides, thumbs, arrows, counter, lightbox,
     and jumping to the variant's image when a variant is chosen
   - option pills that drive the hidden .single-option-selector selects,
     greyed out when that value has no available combination
   - quantity stepper
   - sticky add-to-cart bar that forwards to #AddToCart
   window.SGProduct.onVariant(variant) is called by selectCallback. */
(function () {
  'use strict';

  var root = document.querySelector('[data-sg-product]');
  if (!root) return;

  /* ---------- Gallery ---------- */
  var gallery = root.querySelector('[data-sg-gallery]');
  var track = gallery && gallery.querySelector('[data-gallery-track]');
  var slides = track ? Array.prototype.slice.call(track.querySelectorAll('[data-gallery-slide]')) : [];
  var thumbs = gallery ? Array.prototype.slice.call(gallery.querySelectorAll('[data-gallery-thumb]')) : [];
  var counter = gallery && gallery.querySelector('[data-gallery-index]');
  var current = 0;

  function goTo(i, smooth) {
    if (!track || !slides.length) return;
    current = Math.max(0, Math.min(slides.length - 1, i));
    track.scrollTo({ left: slides[current].offsetLeft, behavior: smooth === false ? 'auto' : 'smooth' });
    mark(current);
  }

  function mark(i) {
    thumbs.forEach(function (t, n) {
      var on = n === i;
      t.classList.toggle('is-active', on);
      if (on) { t.setAttribute('aria-current', 'true'); t.scrollIntoView({ block: 'nearest', inline: 'nearest' }); }
      else t.removeAttribute('aria-current');
    });
    if (counter) counter.textContent = i + 1;
  }

  if (track) {
    var scrollTimer = null;
    track.addEventListener('scroll', function () {
      clearTimeout(scrollTimer);
      scrollTimer = setTimeout(function () {
        var i = Math.round(track.scrollLeft / track.clientWidth);
        if (i !== current) { current = i; mark(i); }
      }, 60);
    }, { passive: true });

    var prev = gallery.querySelector('[data-gallery-prev]');
    var next = gallery.querySelector('[data-gallery-next]');
    if (prev) prev.addEventListener('click', function () { goTo(current - 1 < 0 ? slides.length - 1 : current - 1); });
    if (next) next.addEventListener('click', function () { goTo(current + 1 >= slides.length ? 0 : current + 1); });
    thumbs.forEach(function (t) {
      t.addEventListener('click', function () { goTo(parseInt(t.getAttribute('data-gallery-thumb'), 10)); });
    });
    track.addEventListener('keydown', function (e) {
      if (e.key === 'ArrowRight') { e.preventDefault(); goTo(current + 1); }
      if (e.key === 'ArrowLeft') { e.preventDefault(); goTo(current - 1); }
    });

    // Desktop hover zoom: follow the pointer inside the image
    var fine = window.matchMedia('(hover: hover) and (pointer: fine)');
    slides.forEach(function (slide) {
      var img = slide.querySelector('img');
      if (!img) return;
      slide.addEventListener('pointermove', function (e) {
        if (!fine.matches) return;
        var r = slide.getBoundingClientRect();
        img.style.transformOrigin = ((e.clientX - r.left) / r.width * 100) + '% ' + ((e.clientY - r.top) / r.height * 100) + '%';
        slide.classList.add('is-zoom');
      });
      slide.addEventListener('pointerleave', function () { slide.classList.remove('is-zoom'); });
    });
  }

  /* ---------- Lightbox ---------- */
  var lightbox = root.querySelector('[data-gallery-lightbox]');
  var lbTrack = lightbox && lightbox.querySelector('[data-lightbox-track]');
  if (lightbox && typeof lightbox.showModal === 'function') {
    root.addEventListener('click', function (e) {
      var opener = e.target.closest('[data-gallery-open]');
      if (!opener) return;
      var i = parseInt(opener.getAttribute('data-gallery-open'), 10) || 0;
      lightbox.showModal();
      document.documentElement.classList.add('sg-lightbox-lock');
      var slide = lbTrack.children[i];
      if (slide) lbTrack.scrollTo({ left: slide.offsetLeft, behavior: 'auto' });
    });
    lightbox.addEventListener('click', function (e) {
      if (e.target.closest('[data-lightbox-close]') || e.target === lightbox) lightbox.close();
    });
    lightbox.addEventListener('close', function () { document.documentElement.classList.remove('sg-lightbox-lock'); });
  } else if (lightbox) {
    lightbox.remove();
  }

  /* ---------- Option pills ---------- */
  var fieldsets = Array.prototype.slice.call(root.querySelectorAll('.sg-pdp__option'));
  var variantSelect = root.querySelector('#productSelect');

  function legacySelect(index) {
    return root.querySelector('#productSelect-option-' + index) ||
      root.querySelectorAll('.single-option-selector')[index];
  }

  fieldsets.forEach(function (fs) {
    var index = parseInt(fs.getAttribute('data-option-index'), 10);
    fs.addEventListener('click', function (e) {
      var pill = e.target.closest('[data-option-value]');
      if (!pill || pill.disabled) return;
      var sel = legacySelect(index);
      if (!sel) return;
      sel.value = pill.getAttribute('data-option-value');
      // OptionSelectors listens with onchange; jQuery's trigger calls it (same as the legacy swatches)
      if (window.jQuery) jQuery(sel).trigger('change');
      else sel.dispatchEvent(new Event('change', { bubbles: true }));
    });
    // Arrow keys move between pills (radiogroup pattern)
    fs.addEventListener('keydown', function (e) {
      if (['ArrowRight', 'ArrowDown', 'ArrowLeft', 'ArrowUp'].indexOf(e.key) === -1) return;
      var pills = Array.prototype.slice.call(fs.querySelectorAll('[data-option-value]:not(:disabled)'));
      var at = pills.indexOf(document.activeElement);
      if (at === -1) return;
      e.preventDefault();
      var to = pills[(at + (e.key === 'ArrowRight' || e.key === 'ArrowDown' ? 1 : -1) + pills.length) % pills.length];
      to.focus();
      to.click();
    });
  });

  // Which option values still lead to an available variant, given the others
  function variantsFromSelect() {
    if (!variantSelect) return [];
    return Array.prototype.map.call(variantSelect.options, function (o) {
      // data-title holds the exact variant title (titles can contain " - ")
      var title = o.getAttribute('data-title');
      return { available: !o.disabled, title: title !== null ? title : o.textContent.split(' - ')[0].trim() };
    });
  }

  function updatePills(variant) {
    var options = variant ? variant.options : fieldsets.map(function (fs) {
      var a = fs.querySelector('.is-active'); return a ? a.getAttribute('data-option-value') : null;
    });
    var all = variantsFromSelect();
    fieldsets.forEach(function (fs) {
      var index = parseInt(fs.getAttribute('data-option-index'), 10);
      var selected = options[index];
      var label = fs.querySelector('[data-option-selected]');
      if (label && selected) label.textContent = selected;
      fs.querySelectorAll('[data-option-value]').forEach(function (pill) {
        var value = pill.getAttribute('data-option-value');
        var on = value === selected;
        pill.classList.toggle('is-active', on);
        pill.setAttribute('aria-checked', on ? 'true' : 'false');
        pill.tabIndex = on ? 0 : -1;
        // available if some available variant matches this value + the other current picks
        var probe = options.slice(); probe[index] = value;
        var title = probe.join(' / ');
        var ok = all.some(function (v) { return v.available && v.title === title; });
        pill.classList.toggle('is-unavailable', !ok);
      });
    });
  }

  /* ---------- Quantity ---------- */
  var qty = root.querySelector('.sg-pdp__qty-input');
  root.querySelectorAll('[data-qty-step]').forEach(function (b) {
    b.addEventListener('click', function () {
      var n = Math.max(1, (parseInt(qty.value, 10) || 1) + parseInt(b.getAttribute('data-qty-step'), 10));
      qty.value = n;
    });
  });
  if (qty) qty.addEventListener('change', function () { qty.value = Math.max(1, parseInt(qty.value, 10) || 1); });

  /* ---------- Sticky bar ---------- */
  var bar = root.querySelector('[data-sg-pdp-bar]');
  var buy = root.querySelector('[data-sg-buy]');
  var barBtn = bar && bar.querySelector('[data-bar-add]');
  var barPrice = bar && bar.querySelector('[data-bar-price]');
  var barLabel = bar && bar.querySelector('[data-bar-label]');
  if (bar && buy && 'IntersectionObserver' in window) {
    document.body.appendChild(bar);
    var footer = document.querySelector('.sg-ft');
    var buyVisible = true, footerVisible = false;
    function setBar() {
      var show = !buyVisible && !footerVisible && buy.getBoundingClientRect().top < 0;
      bar.classList.toggle('is-visible', show);
      document.documentElement.classList.toggle('sg-pdp-bar-on', show);
    }
    new IntersectionObserver(function (en) { buyVisible = en[0].isIntersecting; setBar(); }).observe(buy);
    if (footer) new IntersectionObserver(function (en) { footerVisible = en[0].isIntersecting; setBar(); }).observe(footer);
    barBtn.addEventListener('click', function () {
      var atc = document.getElementById('AddToCart');
      if (atc && !atc.disabled) atc.click();
      else buy.scrollIntoView({ behavior: 'smooth', block: 'center' });
    });
  }

  /* ---------- Variant hook (called from selectCallback) ---------- */
  window.SGProduct = {
    onVariant: function (variant) {
      updatePills(variant);
      if (variant && variant.featured_image && slides.length) {
        var id = String(variant.featured_image.id);
        var i = slides.findIndex(function (s) { return s.getAttribute('data-image-id') === id; });
        if (i > -1 && i !== current) goTo(i);
      }
      if (barPrice) {
        var price = document.getElementById('ProductPrice');
        if (price) barPrice.innerHTML = price.innerHTML;
      }
      if (barBtn) {
        var ok = !!(variant && variant.available);
        barBtn.disabled = !ok;
        if (barLabel) barLabel.textContent = ok ? 'Add to cart' : (variant ? 'Sold out' : 'Unavailable');
      }
      var badge = root.querySelector('.sg-pdp__qty');
      if (badge) badge.hidden = !(variant && variant.available);
    }
  };
  updatePills(null);
})();
